var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-end align-end",class:{ 'pa-2': !_vm.dense },attrs:{"id":"filter-alert"}},[_c('v-alert',{staticClass:"mb-0 pa-2 px-2 caption",attrs:{"text":"","color":_vm.isFiltered ? 'success' : 'info'}},[_vm._v(" "+_vm._s(_vm.isFiltered ? _vm.msgFilterInUse : _vm.msgFilterNotUse)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }